// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlayCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
            <g fill="none" fillRule="evenodd">
                <circle cx="31" cy="31" r="31" fill="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M3.13672006,0.303259234 C2.50078243,-0.0877566529 1.70156342,-0.100646753 1.05273503,0.264587622 C0.403906643,0.629821997 0,1.317322 0,2.06497798 L0,17.189978 C0,17.937634 0.403905988,18.625134 1.05273438,18.9903683 C1.70156276,19.3556027 2.50078177,19.3384155 3.13671941,18.9516967 L15.5117194,11.3891967 C16.126172,11.0153681 16.5,10.3493525 16.5,9.62747798 C16.5,8.90560351 16.126172,8.24388437 15.5117194,7.86575923 L3.13671941,0.303259234 L3.13672006,0.303259234 Z"
                    transform="translate(23.25 21.122)"
                />
            </g>
        </svg>
    );
};

export const playCircleString =
    "%3Csvg focusable='false' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' %3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolygon points='10 8 16 12 10 16 10 8'%3E%3C/polygon%3E%3C/svg%3E";

export default React.memo(PlayCircle);
